/* tslint:disable */
/**
 * This file is autogenerated using @sharefiledev/solution-view-engine-tools.
 *
 * Run 'sve typegen <relative path to manifest file>'
 *
 * Types are generated according to specification in a file that conforms to the UI Manifest schema:
 * https://us-solutionviewengine.sharefiletest.io/ui-manifest-v2.json
 */
import { ProjectLifeCycleStage, ProjectStatus } from '@sharefiledev/projects-pilet-sdk';
import type {
	PiletApi,
	PiralCustomExtensionSlotMap as ShellPiralCustomExtensionSlotMap,
} from '@sharefiledev/sharefile-appshell';
import type { BlockParams } from '@sharefiledev/solution-view-engine';

export interface ShellProps {
	piletApi: PiletApi;
}
/** Block parameters for urn:block:projects:project-list-view */

export interface ProjectListViewBlockParams {
	/**
	 * Will be used to fetch the resources whose RID starts with the given containerRID
	 */
	containerRID: string;
	/**
	 * The projectRID will be appended to any path as projectRID (to render project directly) and containerRID (to render any children) query parameters. Default projectNavigationPath value will be /projects/{projectId}.
	 */
	projectNavigationPath?: string;
	/**
	 * object containing localized objects for singular and plural values for project entity name (in title case)
	 */
	projectEntityNameTitleCase?: {
		singular: LocaleStringSchema;
		plural: LocaleStringSchema;
	};
	showClientAssignment?: boolean;
	/**
	 * Specify an event name that should trigger reloading the project list
	 */
	reloadEventName?: string;
	projectTagFilter?: {
		/**
		 * The name of the tag to filter by
		 */
		tagName: string;
		label: string;
		options: {
			displayName: {
				en?: string;
			};
			value: string;
		}[];
	};
	/**
	 * Page limit when rendering results
	 */
	pageLimit?: number;
	allowSaveAsTemplate?: boolean;
	/**
	 * vertical context key will be used to identify which skin to be applied for localization.
	 */
	verticalContextKey?: 'accounting';
	/**
	 * Use a virtual list to improve rendering performance. Default is false.
	 */
	virtual?: boolean;
	emptyState?: EmptyState;
	onCreateProjectInteractionComplete?: OnCompleteInteraction;
}
/**
 * Localization object for configuring string values
 */
export interface LocaleStringSchema {
	en?: string;
	es?: string;
	de?: string;
	fr?: string;
	it?: string;
	ja?: string;
	nl?: string;
	'pt-BR'?: string;
}
/**
 * Empty state object for configuring empty state
 */
export interface EmptyState {
	message?: LocaleStringSchema;
	title?: LocaleStringSchema;
	closedTitle?: LocaleStringSchema;
	searchTitle?: LocaleStringSchema;
}
export interface OnCompleteInteraction {
	eventName: string;
	/**
	 * Describe the payload that should be emitted with the event. Can use the payload from the drawer interaction as a template source with {{data}}.
	 */
	eventPayload?: {
		[k: string]: unknown;
	};
}
/** Zone parameters for urn:zone:projects:view:tabemptystate */

export interface ViewTabemptystateZoneParams {}
/** Contract Data for urn:zone:projects:view:tabemptystate */

export interface ViewTabemptystateContractData {
	isListFiltered?: boolean;
	searchTerm?: string;
	selectedStatus?: 'Open' | 'Closed';
}
/** Block parameters for urn:block:projects:project-list-view:tab-empty-state */

export interface ProjectListViewTabEmptyStateBlockParams {
	message?: LocaleStringSchema;
	title?: LocaleStringSchema;
	closedTitle?: LocaleStringSchema;
	searchTitle?: LocaleStringSchema;
	/**
	 * vertical context key will be used to identify which skin to be applied for localization.
	 */
	verticalContextKey?: 'accounting';
}
/**
 * Localization object for configuring string values
 */
export interface LocaleStringSchema {
	en?: string;
	es?: string;
	de?: string;
	fr?: string;
	it?: string;
	ja?: string;
	nl?: string;
	'pt-BR'?: string;
}
/** Zone parameters for urn:zone:projects:view:tabemptystate:button */

export interface ViewTabemptystateButtonZoneParams {}
/** Block parameters for urn:block:projects:project-life-cycle-stage-aware-view */

export interface ProjectLifeCycleStageAwareViewBlockParams {
	/**
	 * Will be used to fetch the resources whose RID starts with the given containerRID
	 */
	containerRID: string;
}
/** Zone parameters for urn:zone:project:view:life-cycle-stage-aware */

export interface ViewLifeCycleStageAwareZoneParams {}
/** Block parameters for urn:block:projects:headerwithcustomizabletabs:error-state */

export interface HeaderwithcustomizabletabsErrorStateBlockParams {
	message?: LocaleStringSchema;
	title?: LocaleStringSchema;
}
/**
 * Localization object for configuring string values
 */
export interface LocaleStringSchema {
	en?: string;
	es?: string;
	de?: string;
	fr?: string;
	it?: string;
	ja?: string;
	nl?: string;
	'pt-BR'?: string;
}
/** Block parameters for urn:sfblock:projects:headerwithpanel */

export interface HeaderwithpanelBlockParams {
	containerRID: string;
	disableSharingNotification?: boolean;
	hideProjectStatus?: boolean;
	hideBreadcrumbs?: boolean;
	hideMoreOptions?: boolean;
	hideShareButton?: boolean;
	customizedProjectOptions?: string[];
	allowedUserRole?: string;
	permissionsPresets?: {
		rid: string;
		name: LocaleStringSchema;
		presetDescription?: LocaleStringSchema;
		permissions: string[];
	}[];
	enabledResources?: string[];
	disabledResources?: string[];
	enabledPermissions?: string[];
	disabledPermissions?: string[];
	disableCustomPermissions?: boolean;
	/**
	 * object containing localized objects for singular and plural values for project entity name (in title case)
	 */
	projectEntityNameTitleCase?: {
		singular: LocaleStringSchema;
		plural: LocaleStringSchema;
	};
	/**
	 * object containing localized objects for share modal labels
	 */
	shareModalLabels?: {
		title: LocaleStringSchema;
		errorMessage: LocaleStringSchema;
		successMessage: LocaleStringSchema;
	};
	showClientAssignment?: boolean;
	projectEntityName?: LocaleStringSchema;
	breadcrumbOverride?: {
		label: LocaleStringSchema;
		path: string;
	};
	showTour?: boolean;
	solutionAnalyticsId?: string;
	tourSteps?: {
		avatarGroupTourStep?: TourStep;
		shareButtonTourStep?: TourStep;
		moreOptionsTourStep?: TourStep;
	};
	allowSaveAsTemplate?: boolean;
	/**
	 * vertical context key will be used to identify which skin to be applied for localization.
	 */
	verticalContextKey?: 'accounting';
}
/**
 * Localization object for configuring string values
 */
export interface LocaleStringSchema {
	en?: string;
	es?: string;
	de?: string;
	fr?: string;
	it?: string;
	ja?: string;
	nl?: string;
	'pt-BR'?: string;
}
export interface TourStep {
	title: LocaleStringSchema;
	description?: LocaleStringSchema;
	weight: number;
	/**
	 * Any React CSS style options
	 */
	style?: {
		width?: string;
	};
	placement?:
		| 'left'
		| 'leftTop'
		| 'leftBottom'
		| 'right'
		| 'rightTop'
		| 'rightBottom'
		| 'top'
		| 'topLeft'
		| 'topRight'
		| 'bottom'
		| 'bottomLeft'
		| 'bottomRight';
	analyticsId?: string;
}
/** Zone parameters for urn:sfzone:projects:headerwithpanel:panel */

export interface HeaderwithpanelPanelZoneParams {}
/** Contract Data for urn:sfzone:projects:headerwithpanel:panel */

export interface HeaderwithpanelPanelContractData {
	isFrozen?: boolean;
}
/** Block parameters for urn:sfblock:projects:headerwithcustomizabletabs */

export interface HeaderwithcustomizabletabsBlockParams {
	containerRID: string;
	disableSharingNotification?: boolean;
	hideProjectStatus?: boolean;
	hideBreadcrumbs?: boolean;
	hideMoreOptions?: boolean;
	hideShareButton?: boolean;
	customizedProjectOptions?: string[];
	allowedUserRole?: string;
	permissionsPresets?: {
		rid: string;
		name: LocaleStringSchema;
		presetDescription?: LocaleStringSchema;
		permissions: string[];
	}[];
	enabledResources?: string[];
	disabledResources?: string[];
	enabledPermissions?: string[];
	disabledPermissions?: string[];
	disableCustomPermissions?: boolean;
	/**
	 * object containing localized objects for singular and plural values for project entity name (in title case)
	 */
	projectEntityNameTitleCase?: {
		singular: LocaleStringSchema;
		plural: LocaleStringSchema;
	};
	/**
	 * object containing localized objects for share modal labels
	 */
	shareModalLabels?: {
		title: LocaleStringSchema;
		errorMessage: LocaleStringSchema;
		successMessage: LocaleStringSchema;
	};
	showClientAssignment?: boolean;
	projectEntityName?: LocaleStringSchema;
	breadcrumbOverride?: {
		label: LocaleStringSchema;
		path: string;
	};
	showTour?: boolean;
	solutionAnalyticsId?: string;
	tourSteps?: {
		avatarGroupTourStep?: TourStep;
		shareButtonTourStep?: TourStep;
		moreOptionsTourStep?: TourStep;
	};
	allowSaveAsTemplate?: boolean;
	/**
	 * vertical context key will be used to identify which skin to be applied for localization.
	 */
	verticalContextKey?: 'accounting';
}
/**
 * Localization object for configuring string values
 */
export interface LocaleStringSchema {
	en?: string;
	es?: string;
	de?: string;
	fr?: string;
	it?: string;
	ja?: string;
	nl?: string;
	'pt-BR'?: string;
}
export interface TourStep {
	title: LocaleStringSchema;
	description?: LocaleStringSchema;
	weight: number;
	/**
	 * Any React CSS style options
	 */
	style?: {
		width?: string;
	};
	placement?:
		| 'left'
		| 'leftTop'
		| 'leftBottom'
		| 'right'
		| 'rightTop'
		| 'rightBottom'
		| 'top'
		| 'topLeft'
		| 'topRight'
		| 'bottom'
		| 'bottomLeft'
		| 'bottomRight';
	analyticsId?: string;
}
/** Zone parameters for urn:sfzone:projects:view:headerwithcustomizabletabs:tab */

export interface ViewHeaderwithcustomizabletabsTabZoneParams {
	tabName?: LocaleStringSchema;
	tourStep?: {
		title?: LocaleStringSchema;
		description?: LocaleStringSchema;
		weight: number;
		/**
		 * Any React CSS style options
		 */
		style?: {};
		placement?:
			| 'left'
			| 'leftTop'
			| 'leftBottom'
			| 'right'
			| 'rightTop'
			| 'rightBottom'
			| 'top'
			| 'topLeft'
			| 'topRight'
			| 'bottom'
			| 'bottomLeft'
			| 'bottomRight'
			| 'center';
		analyticsId?: string;
	};
}
/**
 * Localization object for configuring string values
 */
export interface LocaleStringSchema {
	en?: string;
	es?: string;
	de?: string;
	fr?: string;
	it?: string;
	ja?: string;
	nl?: string;
	'pt-BR'?: string;
}
/** Contract Data for urn:sfzone:projects:view:headerwithcustomizabletabs:tab */

export interface ViewHeaderwithcustomizabletabsTabContractData {
	isFrozen?: boolean;
}
/** Zone parameters for urn:zone:projects:view:headerwithcustomizabletabs:errorState */

export interface ViewHeaderwithcustomizabletabsErrorstateZoneParams {}
/** Zone parameters for urn:zone:projects:view:projectheader */

export interface ViewProjectheaderZoneParams {}
/** Block parameters for urn:block:projects:projects-view-by-tags */

export interface ProjectsViewByTagsBlockParams {
	/**
	 * Will be used to fetch the resources whose RID starts with the given containerRID
	 */
	containerRID?: string;
	tags: Tag[];
	excludeTags?: Tag[];
	allowSaveAsTemplate?: boolean;
	tagOperator?: 'ALL' | 'ANY';
	showClientAssignment?: boolean;
	/**
	 * The projectRID will be appended to any path as projectRID (to render project directly) and containerRID (to render any children) query parameters. Default projectNavigationPath value will be /projects/{projectId}.
	 */
	projectNavigationPath?: string;
	/**
	 * vertical context key will be used to identify which skin to be applied for localization.
	 */
	verticalContextKey?: string;
	/**
	 * Specify an event name that should trigger reloading the project list
	 */
	reloadEventName?: string;
	emptyState?: EmptyState;
	onCreateProjectInteractionComplete?: OnCompleteInteraction;
}
export interface Tag {
	name: string;
	value: string;
}
/**
 * Empty state object for configuring empty state
 */
export interface EmptyState {
	message?: LocaleStringSchema;
	title?: LocaleStringSchema;
	closedTitle?: LocaleStringSchema;
	searchTitle?: LocaleStringSchema;
}
/**
 * Localization object for configuring string values
 */
export interface LocaleStringSchema {
	en?: string;
	es?: string;
	de?: string;
	fr?: string;
	it?: string;
	ja?: string;
	nl?: string;
	'pt-BR'?: string;
}
export interface OnCompleteInteraction {
	eventName: string;
	/**
	 * Describe the payload that should be emitted with the event. Can use the payload from the drawer interaction as a template source with {{data}}.
	 */
	eventPayload?: {
		[k: string]: unknown;
	};
}
/** Zone parameters for urn:zone:projects:view:extraheaderactions */

export interface ViewExtraheaderactionsZoneParams {}
/** Zone parameters for urn:zone:projects:projects-view-by-tags:tabemptystate */

export interface ProjectsViewByTagsTabemptystateZoneParams {}
/** Contract Data for urn:zone:projects:projects-view-by-tags:tabemptystate */

export interface ProjectsViewByTagsTabemptystateContractData {
	isListFiltered?: boolean;
	searchTerm?: string;
	selectedStatus?: 'Open' | 'Closed';
}
/** Zone parameters for urn:zone:projects:projects-view-by-tags:emptystate:footer */

export interface ProjectsViewByTagsEmptystateFooterZoneParams {}
/** Contract Data for urn:zone:projects:projects-view-by-tags:emptystate:footer */

export interface ProjectsViewByTagsEmptystateFooterContractData {
	isListFiltered?: boolean;
	/**
	 * Search term used.
	 */
	searchTerm?: string;
	/**
	 * The status filter selected.
	 */
	selectedStatus?: 'Open' | 'Closed';
}
/** Block parameters for urn:block:projects:associated-projects-dropdown-header */

export interface AssociatedProjectsDropdownHeaderBlockParams {
	/**
	 * An array of RID strings to preselect in the dropdown. If not provided, the dropdown will manage state internally
	 */
	selectedRIDs?: string[];
	/**
	 * An array of projects to display in the dropdown. If not provided, the dropdown will fetch state from netowrk
	 */
	projects?: {
		name: string;
		resourceId: string;
		lifeCycleStage?: ProjectLifeCycleStage;
		status: ProjectStatus;
	}[];
	/**
	 * Will be used to fetch the resources whose RID starts with the given containerRID if predefined values are not provided
	 */
	containerRID?: string;
	/**
	 * An array of tag name-value pairs (Eg: name- client:entity, value: {{clientRID}}). Will be used to fetch project resources from network if predefined values are not provided
	 */
	tags?: {
		name: string;
		value: string;
	}[];
	/**
	 * The tag operator to search with- ANY for OR operation, ALL for AND operations on tags. If no value is provided, default will be AND operator
	 */
	tagOperator?: string;
	analyticsId?: string;
	/**
	 * The CSS width of the dropdown
	 */
	width?: string;
	containerPadding?: {
		/**
		 * The CSS width of the dropdown
		 */
		smallScreen?: string;
		/**
		 * The CSS width of the dropdown
		 */
		largeScreen?: string;
	};
}
/** Zone parameters for urn:zone:projects:associated-projects-dropdown-header:content */

export interface AssociatedProjectsDropdownHeaderContentZoneParams {}
/** Contract Data for urn:zone:projects:associated-projects-dropdown-header:content */

export interface AssociatedProjectsDropdownHeaderContentContractData {
	projectRID?: string;
}
/** Block parameters for urn:block:projects:suggested-projects */

export interface SuggestedProjectsBlockParams {
	/**
	 * Container RID prefix by which to filter projects
	 */
	containerRIDPrefix?: string;
	/**
	 * An array of user RID strings to filter the suggested projects by
	 */
	userRIDs: string[];
	/**
	 * An array of tag name-value pairs (Eg: name- client:entity, value: {{clientRID}}). This will be used to exclude records where ANY of these tags are already present.
	 */
	excludeTags?: {
		name: string;
		value: string;
	}[];
	/**
	 * If true, the suggested projects block will not be rendered if there are no suggested projects
	 */
	hideEmpty?: boolean;
	/**
	 * Vertical context key will be used to identify which skin to be applied for localization.
	 */
	verticalContextKey?: string;
}
/** Block parameters for urn:block:projects:project-header:tour */

export interface ProjectHeaderTourBlockParams {
	title?: LocaleStringSchema;
	description?: LocaleStringSchema;
}
/**
 * Localization object for configuring string values
 */
export interface LocaleStringSchema {
	en?: string;
	es?: string;
	de?: string;
	fr?: string;
	it?: string;
	ja?: string;
	nl?: string;
	'pt-BR'?: string;
}
/** Block parameters for urn:block:projects:title:inline-meta:options-dropdown */

export interface TitleInlineMetaOptionsDropdownBlockParams {}
/** Block parameters for urn:block:projects:recently-deleted:title:metadata */

export interface RecentlyDeletedTitleMetadataBlockParams {
	/**
	 * vertical context key will be used to identify which skin to be applied for localization.
	 */
	verticalContextKey?: 'accounting';
}
/** Block parameters for urn:block:projects:recently-deleted */

export interface RecentlyDeletedBlockParams {
	/**
	 * Will be used to fetch the resources whose RID starts with the given containerRID
	 */
	containerRID?: string;
	/**
	 * vertical context key will be used to identify which skin to be applied for localization.
	 */
	verticalContextKey?: 'accounting';
}
/** Block parameters for urn:block:projects:project-loader */

export interface ProjectLoaderBlockParams {
	/**
	 * The ResourceId (RID) of a specific project resource. If not specified, loader will attempt to look to the URL query params for "projectRID"
	 */
	projectRID?: string;
}
/** Block parameters for urn:block:projects:create-project-menu-button */

export interface CreateProjectMenuButtonBlockParams {
	onCreateProjectInteractionComplete?: OnCompleteInteraction;
	/**
	 * Array of menu option configurations to display in the create project menu. If provided, this will override the default menu options.
	 */
	menuOptions?: {
		/**
		 * Unique identifier for the menu option
		 */
		id: 'create-blank-project' | 'create-project-from-template';
		/**
		 * The action type to perform when the menu option is selected
		 */
		action: 'createBlank' | 'createFromTemplate';
	}[];
}
export interface OnCompleteInteraction {
	eventName: string;
	/**
	 * Describe the payload that should be emitted with the event. Can use the payload from the drawer interaction as a template source with {{data}}.
	 */
	eventPayload?: {
		[k: string]: unknown;
	};
}
/** Block parameters for urn:block:projects:new-project-options */

export interface NewProjectOptionsBlockParams {
	/**
	 * If true, the New Project button will be hidden
	 */
	hideNewProjectButton?: boolean;
	/**
	 * If true, the From Template button will be hidden
	 */
	hideFromTemplateButton?: boolean;
	onCompleteNavigationPath?: string;
}
/** Block parameters for urn:block:projects:provider */

export interface ProviderBlockParams {
	containerRID: string;
}
/** Zone parameters for urn:zone:projects:provider:children */

export interface ProviderChildrenZoneParams {}
/** Contract Data for urn:zone:projects:provider:children */

export interface ProviderChildrenContractData {
	hasProjects?: boolean;
	hasDeletedProjects?: boolean;
	isClient?: boolean;
}
/** Block parameters for urn:block:projects:projectdetailsprovider */

export interface ProjectdetailsproviderBlockParams {
	/**
	 * The ResourceId (RID) of a specific project resource. If not specified, will attempt to read from URL query params
	 */
	projectRID?: string;
}
/** Zone parameters for urn:zone:projects:projectdetailsprovider:children */

export interface ProjectdetailsproviderChildrenZoneParams {}
/** Contract Data for urn:zone:projects:projectdetailsprovider:children */

export interface ProjectdetailsproviderChildrenContractData {
	projectRID?: string;
}
/** Block parameters for urn:block:projects:project-list-view:ftu-state */

export interface ProjectListViewFtuStateBlockParams {
	message?: LocaleStringSchema;
	title?: LocaleStringSchema;
	/**
	 * vertical context key will be used to identify which skin to be applied for localization.
	 */
	verticalContextKey?: 'accounting';
	/**
	 * If true, custom styles will be applied to the empty state. Default is false.
	 */
	applyCustomStyles?: boolean;
}
/**
 * Localization object for configuring string values
 */
export interface LocaleStringSchema {
	en?: string;
	es?: string;
	de?: string;
	fr?: string;
	it?: string;
	ja?: string;
	nl?: string;
	'pt-BR'?: string;
}
/** Block parameters for urn:block:projects:project-link */

export interface ProjectLinkBlockParams {
	/**
	 * The Resource ID (RID) of the project to display and link to
	 */
	projectRID: string;
}

export namespace BlockNames {
	export const ProjectListView = 'urn:block:projects:project-list-view' as const;
	export type ProjectListView = 'urn:block:projects:project-list-view';
	export const ProjectListViewTabEmptyState =
		'urn:block:projects:project-list-view:tab-empty-state' as const;
	export type ProjectListViewTabEmptyState =
		'urn:block:projects:project-list-view:tab-empty-state';
	export const ProjectLifeCycleStageAwareView =
		'urn:block:projects:project-life-cycle-stage-aware-view' as const;
	export type ProjectLifeCycleStageAwareView =
		'urn:block:projects:project-life-cycle-stage-aware-view';
	export const HeaderwithcustomizabletabsErrorState =
		'urn:block:projects:headerwithcustomizabletabs:error-state' as const;
	export type HeaderwithcustomizabletabsErrorState =
		'urn:block:projects:headerwithcustomizabletabs:error-state';
	export const Headerwithpanel = 'urn:sfblock:projects:headerwithpanel' as const;
	export type Headerwithpanel = 'urn:sfblock:projects:headerwithpanel';
	export const Headerwithcustomizabletabs =
		'urn:sfblock:projects:headerwithcustomizabletabs' as const;
	export type Headerwithcustomizabletabs =
		'urn:sfblock:projects:headerwithcustomizabletabs';
	export const ProjectsViewByTags = 'urn:block:projects:projects-view-by-tags' as const;
	export type ProjectsViewByTags = 'urn:block:projects:projects-view-by-tags';
	export const AssociatedProjectsDropdownHeader =
		'urn:block:projects:associated-projects-dropdown-header' as const;
	export type AssociatedProjectsDropdownHeader =
		'urn:block:projects:associated-projects-dropdown-header';
	export const SuggestedProjects = 'urn:block:projects:suggested-projects' as const;
	export type SuggestedProjects = 'urn:block:projects:suggested-projects';
	export const ProjectHeaderTour = 'urn:block:projects:project-header:tour' as const;
	export type ProjectHeaderTour = 'urn:block:projects:project-header:tour';
	export const TitleInlineMetaOptionsDropdown =
		'urn:block:projects:title:inline-meta:options-dropdown' as const;
	export type TitleInlineMetaOptionsDropdown =
		'urn:block:projects:title:inline-meta:options-dropdown';
	export const RecentlyDeletedTitleMetadata =
		'urn:block:projects:recently-deleted:title:metadata' as const;
	export type RecentlyDeletedTitleMetadata =
		'urn:block:projects:recently-deleted:title:metadata';
	export const RecentlyDeleted = 'urn:block:projects:recently-deleted' as const;
	export type RecentlyDeleted = 'urn:block:projects:recently-deleted';
	export const ProjectLoader = 'urn:block:projects:project-loader' as const;
	export type ProjectLoader = 'urn:block:projects:project-loader';
	export const CreateProjectMenuButton =
		'urn:block:projects:create-project-menu-button' as const;
	export type CreateProjectMenuButton = 'urn:block:projects:create-project-menu-button';
	export const NewProjectOptions = 'urn:block:projects:new-project-options' as const;
	export type NewProjectOptions = 'urn:block:projects:new-project-options';
	export const Provider = 'urn:block:projects:provider' as const;
	export type Provider = 'urn:block:projects:provider';
	export const Projectdetailsprovider =
		'urn:block:projects:projectdetailsprovider' as const;
	export type Projectdetailsprovider = 'urn:block:projects:projectdetailsprovider';
	export const ProjectListViewFtuState =
		'urn:block:projects:project-list-view:ftu-state' as const;
	export type ProjectListViewFtuState = 'urn:block:projects:project-list-view:ftu-state';
	export const ProjectLink = 'urn:block:projects:project-link' as const;
	export type ProjectLink = 'urn:block:projects:project-link';
}

export namespace ZoneTypes {
	export const ViewTabemptystate = 'urn:zone:projects:view:tabemptystate' as const;
	export type ViewTabemptystate = 'urn:zone:projects:view:tabemptystate';
	export const ViewTabemptystateButton =
		'urn:zone:projects:view:tabemptystate:button' as const;
	export type ViewTabemptystateButton = 'urn:zone:projects:view:tabemptystate:button';
	export const ViewLifeCycleStageAware =
		'urn:zone:project:view:life-cycle-stage-aware' as const;
	export type ViewLifeCycleStageAware = 'urn:zone:project:view:life-cycle-stage-aware';
	export const HeaderwithpanelPanel =
		'urn:sfzone:projects:headerwithpanel:panel' as const;
	export type HeaderwithpanelPanel = 'urn:sfzone:projects:headerwithpanel:panel';
	export const ViewHeaderwithcustomizabletabsTab =
		'urn:sfzone:projects:view:headerwithcustomizabletabs:tab' as const;
	export type ViewHeaderwithcustomizabletabsTab =
		'urn:sfzone:projects:view:headerwithcustomizabletabs:tab';
	export const ViewHeaderwithcustomizabletabsErrorstate =
		'urn:zone:projects:view:headerwithcustomizabletabs:errorState' as const;
	export type ViewHeaderwithcustomizabletabsErrorstate =
		'urn:zone:projects:view:headerwithcustomizabletabs:errorState';
	export const ViewProjectheader = 'urn:zone:projects:view:projectheader' as const;
	export type ViewProjectheader = 'urn:zone:projects:view:projectheader';
	export const ViewExtraheaderactions =
		'urn:zone:projects:view:extraheaderactions' as const;
	export type ViewExtraheaderactions = 'urn:zone:projects:view:extraheaderactions';
	export const ProjectsViewByTagsTabemptystate =
		'urn:zone:projects:projects-view-by-tags:tabemptystate' as const;
	export type ProjectsViewByTagsTabemptystate =
		'urn:zone:projects:projects-view-by-tags:tabemptystate';
	export const ProjectsViewByTagsEmptystateFooter =
		'urn:zone:projects:projects-view-by-tags:emptystate:footer' as const;
	export type ProjectsViewByTagsEmptystateFooter =
		'urn:zone:projects:projects-view-by-tags:emptystate:footer';
	export const AssociatedProjectsDropdownHeaderContent =
		'urn:zone:projects:associated-projects-dropdown-header:content' as const;
	export type AssociatedProjectsDropdownHeaderContent =
		'urn:zone:projects:associated-projects-dropdown-header:content';
	export const ProviderChildren = 'urn:zone:projects:provider:children' as const;
	export type ProviderChildren = 'urn:zone:projects:provider:children';
	export const ProjectdetailsproviderChildren =
		'urn:zone:projects:projectdetailsprovider:children' as const;
	export type ProjectdetailsproviderChildren =
		'urn:zone:projects:projectdetailsprovider:children';
}

export type ProjectListViewProps = ShellProps & BlockParams & ProjectListViewBlockParams;
export type ProjectListViewTabEmptyStateProps = ShellProps &
	BlockParams &
	ProjectListViewTabEmptyStateBlockParams;
export type ProjectLifeCycleStageAwareViewProps = ShellProps &
	BlockParams &
	ProjectLifeCycleStageAwareViewBlockParams;
export type HeaderwithcustomizabletabsErrorStateProps = ShellProps &
	BlockParams &
	HeaderwithcustomizabletabsErrorStateBlockParams;
export type HeaderwithpanelProps = ShellProps & BlockParams & HeaderwithpanelBlockParams;
export type HeaderwithcustomizabletabsProps = ShellProps &
	BlockParams &
	HeaderwithcustomizabletabsBlockParams;
export type ProjectsViewByTagsProps = ShellProps &
	BlockParams &
	ProjectsViewByTagsBlockParams;
export type AssociatedProjectsDropdownHeaderProps = ShellProps &
	BlockParams &
	AssociatedProjectsDropdownHeaderBlockParams;
export type SuggestedProjectsProps = ShellProps &
	BlockParams &
	SuggestedProjectsBlockParams;
export type ProjectHeaderTourProps = ShellProps &
	BlockParams &
	ProjectHeaderTourBlockParams;
export type TitleInlineMetaOptionsDropdownProps = ShellProps &
	BlockParams &
	TitleInlineMetaOptionsDropdownBlockParams;
export type RecentlyDeletedTitleMetadataProps = ShellProps &
	BlockParams &
	RecentlyDeletedTitleMetadataBlockParams;
export type RecentlyDeletedProps = ShellProps & BlockParams & RecentlyDeletedBlockParams;
export type ProjectLoaderProps = ShellProps & BlockParams & ProjectLoaderBlockParams;
export type CreateProjectMenuButtonProps = ShellProps &
	BlockParams &
	CreateProjectMenuButtonBlockParams;
export type NewProjectOptionsProps = ShellProps &
	BlockParams &
	NewProjectOptionsBlockParams;
export type ProviderProps = ShellProps & BlockParams & ProviderBlockParams;
export type ProjectdetailsproviderProps = ShellProps &
	BlockParams &
	ProjectdetailsproviderBlockParams;
export type ProjectListViewFtuStateProps = ShellProps &
	BlockParams &
	ProjectListViewFtuStateBlockParams;
export type ProjectLinkProps = ShellProps & BlockParams & ProjectLinkBlockParams;

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		['urn:block:projects:project-list-view']: BlockParams & ProjectListViewBlockParams;
		['urn:block:projects:project-list-view:tab-empty-state']: BlockParams &
			ProjectListViewTabEmptyStateBlockParams;
		['urn:block:projects:project-life-cycle-stage-aware-view']: BlockParams &
			ProjectLifeCycleStageAwareViewBlockParams;
		['urn:block:projects:headerwithcustomizabletabs:error-state']: BlockParams &
			HeaderwithcustomizabletabsErrorStateBlockParams;
		['urn:sfblock:projects:headerwithpanel']: BlockParams & HeaderwithpanelBlockParams;
		['urn:sfblock:projects:headerwithcustomizabletabs']: BlockParams &
			HeaderwithcustomizabletabsBlockParams;
		['urn:block:projects:projects-view-by-tags']: BlockParams &
			ProjectsViewByTagsBlockParams;
		['urn:block:projects:associated-projects-dropdown-header']: BlockParams &
			AssociatedProjectsDropdownHeaderBlockParams;
		['urn:block:projects:suggested-projects']: BlockParams & SuggestedProjectsBlockParams;
		['urn:block:projects:project-header:tour']: BlockParams &
			ProjectHeaderTourBlockParams;
		['urn:block:projects:title:inline-meta:options-dropdown']: BlockParams &
			TitleInlineMetaOptionsDropdownBlockParams;
		['urn:block:projects:recently-deleted:title:metadata']: BlockParams &
			RecentlyDeletedTitleMetadataBlockParams;
		['urn:block:projects:recently-deleted']: BlockParams & RecentlyDeletedBlockParams;
		['urn:block:projects:project-loader']: BlockParams & ProjectLoaderBlockParams;
		['urn:block:projects:create-project-menu-button']: BlockParams &
			CreateProjectMenuButtonBlockParams;
		['urn:block:projects:new-project-options']: BlockParams &
			NewProjectOptionsBlockParams;
		['urn:block:projects:provider']: BlockParams & ProviderBlockParams;
		['urn:block:projects:projectdetailsprovider']: BlockParams &
			ProjectdetailsproviderBlockParams;
		['urn:block:projects:project-list-view:ftu-state']: BlockParams &
			ProjectListViewFtuStateBlockParams;
		['urn:block:projects:project-link']: BlockParams & ProjectLinkBlockParams;
	}
}

declare module '@sharefiledev/solution-view-engine' {
	interface BlockCustomExtensionSlotMap extends ShellPiralCustomExtensionSlotMap {}

	interface PiletExtensionApi extends PiletApi {}

	interface ViewEngineCustomZoneParametersMap {
		['urn:zone:projects:view:tabemptystate']: ViewTabemptystateZoneParams;
		['urn:zone:projects:view:tabemptystate:button']: ViewTabemptystateButtonZoneParams;
		['urn:zone:project:view:life-cycle-stage-aware']: ViewLifeCycleStageAwareZoneParams;
		['urn:sfzone:projects:headerwithpanel:panel']: HeaderwithpanelPanelZoneParams;
		['urn:sfzone:projects:view:headerwithcustomizabletabs:tab']: ViewHeaderwithcustomizabletabsTabZoneParams;
		['urn:zone:projects:view:headerwithcustomizabletabs:errorState']: ViewHeaderwithcustomizabletabsErrorstateZoneParams;
		['urn:zone:projects:view:projectheader']: ViewProjectheaderZoneParams;
		['urn:zone:projects:view:extraheaderactions']: ViewExtraheaderactionsZoneParams;
		['urn:zone:projects:projects-view-by-tags:tabemptystate']: ProjectsViewByTagsTabemptystateZoneParams;
		['urn:zone:projects:projects-view-by-tags:emptystate:footer']: ProjectsViewByTagsEmptystateFooterZoneParams;
		['urn:zone:projects:associated-projects-dropdown-header:content']: AssociatedProjectsDropdownHeaderContentZoneParams;
		['urn:zone:projects:provider:children']: ProviderChildrenZoneParams;
		['urn:zone:projects:projectdetailsprovider:children']: ProjectdetailsproviderChildrenZoneParams;
	}

	interface ViewEngineCustomZoneContractDataMap {
		['urn:zone:projects:view:tabemptystate']: ViewTabemptystateContractData;
		['urn:zone:projects:view:tabemptystate:button']: never;
		['urn:zone:project:view:life-cycle-stage-aware']: never;
		['urn:sfzone:projects:headerwithpanel:panel']: HeaderwithpanelPanelContractData;
		['urn:sfzone:projects:view:headerwithcustomizabletabs:tab']: ViewHeaderwithcustomizabletabsTabContractData;
		['urn:zone:projects:view:headerwithcustomizabletabs:errorState']: never;
		['urn:zone:projects:view:projectheader']: never;
		['urn:zone:projects:view:extraheaderactions']: never;
		['urn:zone:projects:projects-view-by-tags:tabemptystate']: ProjectsViewByTagsTabemptystateContractData;
		['urn:zone:projects:projects-view-by-tags:emptystate:footer']: ProjectsViewByTagsEmptystateFooterContractData;
		['urn:zone:projects:associated-projects-dropdown-header:content']: AssociatedProjectsDropdownHeaderContentContractData;
		['urn:zone:projects:provider:children']: ProviderChildrenContractData;
		['urn:zone:projects:projectdetailsprovider:children']: ProjectdetailsproviderChildrenContractData;
	}
}
